import { useWidgetData } from "../Contexts/dashboardHooks";
import type { PlayerNotesComponentSpec } from "../Processing/types";
import { resolveDateRange } from "../Utils/resolveDateRange";

function buildInfoContent(spec: PlayerNotesComponentSpec, noteIds: string[], searchPattern?: string): React.ReactNode {
  const misc = spec.player_notes_builder_misc;
  const dateLabel = resolveDateRange(misc);
  const subjectsLabel = misc?.selectedSubjectNames?.length
    ? misc.selectedSubjectNames.join(", ")
    : "Full Team";

  return (
    <div style={{ maxWidth: 280, fontSize: 12, lineHeight: 1.6 }}>
      <div style={{ paddingLeft: 4, color: "rgba(0,0,0,0.65)" }}>
        <div>Dates: {dateLabel}</div>
        <div>Players: {subjectsLabel}</div>
        {noteIds.length > 0 && <div>Specific Notes: {noteIds.length}</div>}
        {searchPattern && <div>Search: &lsquo;{searchPattern}&rsquo;</div>}
      </div>
    </div>
  );
}

export function PlayerNotesInfo({ id }: { id: string }) {
  const data = useWidgetData(id);
  if (!data || data.type !== "player_notes") return null;
  const { noteIds, searchPattern } = data.notes;
  return buildInfoContent(data.spec, noteIds, searchPattern);
}
